import { render } from "./index.vue?vue&type=template&id=ea23aa06&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ea23aa06&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=ea23aa06&lang=less"
script.render = render
script.__scopeId = "data-v-ea23aa06"

export default script